function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.124 1.227c1.45 0 2.623 1.185 2.623 2.644 0 .097 0 .18-.01.267l-.032.243.085.02c.698.212 1.195.867 1.195 1.63 0 .887-.667 1.617-1.523 1.712H1.714C.77 7.742 0 6.982 0 6.03c0-.942.772-1.715 1.713-1.715l.15.01.05-.115c.298-.54.87-.91 1.535-.91l.106.01.063-.22c.328-1.08 1.322-1.863 2.507-1.863z",
  fill: "#a6a6a6",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.124 1.777c1.153 0 2.094.93 2.094 2.084 0 .17-.02.33-.052.478l-.127.35.114.178.127-.01c.646 0 1.175.518 1.175 1.163 0 .602-.465 1.1-1.047 1.163H1.713c-.646 0-1.175-.518-1.175-1.164 0-.646.528-1.164 1.173-1.164.076 0 .16.01.234.02l.106.033.222-.118.148-.38c.212-.338.592-.57 1.016-.57.084 0 .17.01.243.02l.18.064.18-.137.042-.34c.19-.95 1.036-1.67 2.04-1.67z",
  fill: "#434343",
  fillRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.525 4.038l-.486.408 1.518.41-.145-1.588-.51.428c-1.136-.875-2.495-.19-2.824.832-.1.428.402.45.467.147.18-.593 1.1-1.255 1.978-.638zM5.03 6.108l.48-.402-1.53-.442.165 1.614.51-.43c1.147.89 2.49.217 2.813-.812.08-.413-.413-.44-.484-.147-.158.6-1.078 1.25-1.953.617z",
  fill: "#f90",
  fillRule: "evenodd"
});

var SvgLicense30Days = function SvgLicense30Days(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "9.9847851mm",
    height: "7.7424402mm",
    viewBox: "0 0 9.9847852 7.7424402",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLicense30Days, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/License-30Days.556e0fa3.svg";
export { ForwardRef as ReactComponent };